import { Stack, Button } from "@mui/material";
import {LoadingButton} from '@mui/lab';
import { txt } from "../../services/translation";

export default function FormButtons({onCancel, loading, submitText}){

    return <Stack direction='row' spacing={2} justifyContent='end'>

        <Button 
            variant='outlined' 
            type='button' 
            onClick={onCancel}
        >
            {txt('cancel')}
        </Button>

        <LoadingButton 
            variant='contained' 
            type='submit' 
            loading={loading}
        >
            {submitText || txt('validate')}
        </LoadingButton>

    </Stack>

}